<template>
  <footer class="footerBox flex column ai">
    <img class="logo" src="@/assets/mobile/iconLogo.png" alt="" />
    <div class="boxJump flex column ai jcs">
      <div @click="jumpToExternal('Bayer Global')" class="jumpTitle">Bayer Global</div>
      <div @click="jumpToExternal('Bayer CN')" class="jumpTitle">Bayer CN</div>
      <div @click="jumpToExternal('联系我们')" class="jumpTitle">联系我们</div>
      <div @click="jumpToExternal('使用条款')" class="jumpTitle">使用条款</div>
    </div>
    <div class="filing-numberBox flex jcc">
      <div @click="jumpToExternal('备案')" class="filing-number">沪ICP备2025113661号-1</div>
      <div class="filing-number"></div>
    </div>
  </footer>
  <!-- 跳转弹窗 -->
  <div v-if="showPopUpJump" class="popup-jump flex ai jcc">
    <div class="jumpBox flex column ai">
      <div class="jumpTxt1">您正在离开One A Day官网页面</div>
      <div class="jumpTxt2">你已选择进入第三方网站，你将离开拜耳所属的网站并去往第三方独立运营并不被拜耳管理的网络平台。拜耳将不对上述网站的内容及运营承担任何责任。</div>
      <div class="jumpTxt3">点击“取消”返回当前One A Day网页，点击“继续”访问第三方网站。</div>
      <div class="flex jcs" style="width: 100%; margin-top: 0.32rem; padding: 0 1.2rem; box-sizing: border-box">
        <div @click="jumpExternal" class="btnContinue flex ai jcc">继续</div>
        <div @click="showPopUpJump = false" class="btnCancel flex ai jcc">取消</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
// 是否展示跳转弹窗
const showPopUpJump = ref(false);
// 跳转名称
const jumpName = ref("");
// 跳转外部网站
const jumpToExternal = (name) => {
  // showPopUpJump.value = true;
  // jumpName.value = name;
  if (name == "Bayer Global") {
    window.location.href = "https://www.bayer.com/en/";
  } else if (name == "Bayer CN") {
    window.location.href = "https://www.bayer.com.cn/zh-hans/";
  } else if (name == "联系我们") {
    router.push({ name: "mobileContactUs" });
  } else if (name == "使用条款") {
    router.push({ name: "mobileTermsOfUse" });
  }
};
const jumpExternal = () => {
  if (jumpName.value == "Bayer Global") {
    window.location.href = "https://www.bayer.com/en/";
  } else if (jumpName.value == "Bayer CN") {
    window.location.href = "https://www.bayer.com.cn/zh-hans/";
  }
};
</script>

<style lang="scss" scoped>
.footerBox {
  width: 100%;
  left: 0;
  height: 7.32rem;
  background: #140e4f;
}

.logo {
  margin-top: 0.63rem;
  width: 4.4rem;
  height: 1.79rem;
}
.boxJump {
  margin-top: 0.73rem;
  width: 4.2rem;
  height: 2.66rem;
}
.jumpTitle {
  font-family: SourceHanSansSC-Heavy;
  font-weight: bold;
  font-size: 0.35rem;
  color: #ffffff;
  line-height: 0.35rem;
  white-space: nowrap;
}
.filing-number {
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.22rem;
  color: #ffffff;
}
.filing-numberBox {
  margin-top: 0.82rem;
  width: 5.77rem;
}
.popup-jump {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.jumpBox {
  width: 6.34rem;
  background: #ffffff;
  opacity: 0.95;
  border-radius: 0.1rem;
  padding: 0.42rem 0.34rem;
  box-sizing: border-box;
}

.jumpTxt1 {
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 0.33rem;
  color: #140e4f;
}

.jumpTxt2 {
  margin-top: 0.41rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.21rem;
  color: #140e4f;
  line-height: 0.28rem;
}

.jumpTxt3 {
  margin-top: 0.18rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.21rem;
  color: #140e4f;
  line-height: 0.28rem;
}

.btnContinue {
  width: 1.14rem;
  height: 0.4rem;
  border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
  border: 0.01rem solid #140e4f;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 0.26rem;
  color: #140e4f;
  line-height: 0.26rem;
}

.btnCancel {
  width: 1.14rem;
  height: 0.44rem;
  background: #140e4f;
  border-radius: 0.03rem;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 0.26rem;
  color: #ffffff;
  line-height: 0.26rem;
}
</style>
